import * as React from 'react';
import StoreGroupFinderContainerV2 from '../../components/StoreGroupFinderV2/StoreGroupFinderContainerV2.js';
import '../../context/StoreFinder/context.js';
import { StoreFinderProvider } from '../../context/StoreFinder/provider.js';
import '../../context/StoreFinderSlots/context.js';

const StoreGroupRoot = ({ groupName , hideEmail , hidePhone , stores , storeFilters , urls ,  })=>{
    return /*#__PURE__*/ React.createElement(StoreFinderProvider, {
        googleMapsId: "google-maps-container",
        withUrlParams: true,
        hidePhone: hidePhone,
        hideEmail: hideEmail,
        initialStores: stores !== null && stores !== void 0 ? stores : undefined,
        isStoreFiltersButtonEnabled: true,
        urls: urls
    }, /*#__PURE__*/ React.createElement("style", {
        jsx: true,
        global: true
    }, `
        .banner,
        .notification-bar {
          position: relative;
          z-index: 100;
        }
      `), /*#__PURE__*/ React.createElement(StoreGroupFinderContainerV2, {
        groupName: groupName,
        storeFilters: storeFilters,
        urls: urls
    }));
};

export { StoreGroupRoot as default };
//# sourceMappingURL=StoreGroupRootV2.js.map
